const ForecastRightPanel = ({ open, widthClass = 'flex-1', children }) => {
    if (!open) return null;
    return (
        <section
            className={`flex flex-col bg-white dark:bg-slate-800 border-l border-slate-200 dark:border-slate-700 min-w-0 overflow-hidden ${widthClass}`}
            data-testid="forecast-right-panel"
        >
            <div className="flex-1 overflow-auto">
                {children}
            </div>
        </section>
    );
};

export default ForecastRightPanel;
